import { render } from "./NewsItemEdit.vue?vue&type=template&id=620c04ae"
import script from "./NewsItemEdit.vue?vue&type=script&lang=js"
export * from "./NewsItemEdit.vue?vue&type=script&lang=js"

import exportComponent from "/srv/volumes/sshfs-rpi3ex/intermagtech/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__